module.exports = __webpack_public_path__ + "img/location.9ea85554.png";